import classnames from 'classnames';
import { truncate } from 'lodash';
import * as monacoEditor from 'monaco-editor';
import React from 'react';

import { useDerivedEditorValue } from 'src/app/graph/explorerPage/hooks/useDerivedEditorValue';
import { EditorViewZone } from 'src/components/editorViewZone/EditorViewZone';

const MAX_HINT_LENGTH = 25;

/**
 * A hint at the end of the given line.
 */
export const EditorHint = ({
  className,
  editor,
  lineNumber,
  hint,
}: {
  className?: string;
  editor: monacoEditor.editor.IStandaloneCodeEditor;
  lineNumber: number;
  hint: string;
}) => {
  const transformedHint = hint.replace(/"/g, '');
  const truncatedHint = truncate(transformedHint, { length: MAX_HINT_LENGTH });
  const isSelectedLine = useDerivedEditorValue({
    editor,
    getValue: React.useCallback(
      (_, position: monacoEditor.Position | undefined) =>
        position?.lineNumber === lineNumber,
      [lineNumber],
    ),
    withPosition: true,
  });

  return (
    <EditorViewZone className="z-20" editor={editor} lineNumber={lineNumber}>
      <div
        className={classnames(
          className,
          'absolute right-0 top-0 mr-6 flex items-center text-sm',
          isSelectedLine ? 'text-primary' : 'text-secondary',
        )}
      >
        {truncatedHint}
      </div>
    </EditorViewZone>
  );
};
